import { ApiResult, HttpClient } from "../http.js";

/**
 * Customer side of a supplier sortiment ("Bygma tilbyder sin prisliste"). Active org = the customer company.
 * Accept / unsubscribe need `priceLibrary.edit` and are refused in supplier sessions. Refusals: 404 `offer_not_found`,
 * 409 `offer_not_open` (accept).
 */
export type CatalogOfferStatus = "Offered" | "Active" | "Unsubscribed";

export interface CatalogOfferDto {
  subscriptionId: string;
  catalogId: string;
  catalogName: string;
  supplierCompanyId: string;
  supplierName: string;
  status: CatalogOfferStatus;
  /** Null until the first sync has run. */
  priceListSupplierId: string | null;
  publishedVersion: number;
  lastSyncedVersion: number;
  lastSyncedAt: string | null;
  lastError: string | null;
}

export class CatalogOffersApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<CatalogOfferDto[]>> {
    return this.http.get<CatalogOfferDto[]>("/api/catalog-offers");
  }

  accept(subscriptionId: string): Promise<ApiResult<CatalogOfferDto>> {
    return this.http.post<CatalogOfferDto>(`/api/catalog-offers/${encodeURIComponent(subscriptionId)}/accept`);
  }

  /** Also declines an open offer. Synced rows stay in the price list, frozen. */
  unsubscribe(subscriptionId: string): Promise<ApiResult<CatalogOfferDto>> {
    return this.http.post<CatalogOfferDto>(`/api/catalog-offers/${encodeURIComponent(subscriptionId)}/unsubscribe`);
  }
}
